module.exports = __webpack_public_path__ + "media/Text_headline_+_16x9.45dc423d.mp4";